import React, { useMemo } from "react";
import CardTemplate from "components/card/card-template/CardTemplate";
import { useQuote } from "hooks/useQuote";
import { useContactInformation } from "hooks/useContactInformation";
import { getAgreementTexts } from "constants/agreementTexts";

interface AgreementProps {
    className?: string;
}

const Agreement = ({ className = "" }: AgreementProps) => {
    // ========== Hooks ==========
    const { quoteData } = useQuote();
    const { contactData } = useContactInformation();

    // ========== Computed Values ==========
    const state = quoteData?.state || "";
    const firstName = contactData?.contactInformation?.firstName || "[First Last]";

    const agreementTexts = useMemo(() => getAgreementTexts(state), [state]);

    // ========== Render ==========
    return (
        <CardTemplate title="" className={className} px="px-6 tablet:px-6">
            <div className="flex flex-col gap-4" id="agreement-content">
                {/* Acknowledgements */}
                {agreementTexts.acknowledgement && (
                    <div className="flex flex-col pt-6" id="agreement-acknowledgement">
                        <p className="text-base-content font-medium text-sm leading-5 font-sans">
                            I, {firstName}, understand that by selecting "Submit" below, I am applying for Direct Term Life
                            Insurance from AAA Life.
                        </p>
                        <br />
                        <p
                            className="text-base-content font-medium text-sm leading-5 font-sans"
                            dangerouslySetInnerHTML={{ __html: agreementTexts.acknowledgement }}
                        />
                    </div>
                )}

                {/* Fraud Warning */}
                <div className="flex flex-col gap-4" id="agreement-fraud-warning">
                    <h3 className="font-sans font-bold text-lg leading-7 text-base-content">Fraud Warning</h3>
                    <p
                        className="text-base-content font-medium text-sm leading-5 font-sans"
                        dangerouslySetInnerHTML={{ __html: agreementTexts.fraudWarning }}
                    />
                </div>

                {/* Consent for Electronic Signature */}
                <div className="flex flex-col gap-4" id="agreement-electronic-signature">
                    <h3 className="font-sans font-bold text-lg leading-7 text-base-content">
                        Consent for Electronic Signature
                    </h3>
                    <p
                        className="text-base-content font-medium text-sm leading-5 font-sans"
                        dangerouslySetInnerHTML={{ __html: agreementTexts.consentElectronicSignature }}
                    />
                </div>
            </div>
        </CardTemplate>
    );
};

Agreement.displayName = "Agreement";

export default Agreement;
